import React, { useEffect, useState } from 'react'
import { HomeOutlined, UserOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLink, getRoute } from './routes';

const itemsInitialState = {
  first:{
    link: '',
    name: '',
  },
  second: {
    link: '',
    name: '',
  },
}

function AdvancedBreadcrumb() {
  
  const history = useNavigate()
  const { pathname } = useLocation()
  const [item, setItem] = useState(itemsInitialState)


  const validateItems = (breadItems: Array<string>) => {

    if(breadItems.length > 0 && breadItems[2] === 'new') {
      breadItems[2] = `Create or edit`
    }
    setItem({
      first: {
        link: breadItems[1] ? getLink(breadItems[1]) : '',
        name:  breadItems[1] ? getRoute(breadItems[1]) : '',
      },
      second: {
        link: breadItems[2] ? `/${breadItems[2]}` : '',
        name: breadItems[2] ? breadItems[2].replaceAll('%20', ' ') : '',
      }
    })
  }

  const hideBreadCrumb =  window.location.pathname === '/reports' || 
                          window.location.pathname === '/distributorserver' ||
                          window.location.pathname.includes('/distributorservers/') ||
                          window.location.pathname.includes('/distributorserver/new') ||
                          window.location.pathname.includes('/games/settings/')

  useEffect(() => {
    const breadItems = pathname.split('/')
    validateItems(breadItems)
  }, [pathname])

  const buildItems = () => {
    const items = [
      {
        title:<a onClick={() => history('/welcome')} href='#'><HomeOutlined style={{fontSize: 18}} /></a>
      },
      {
        title:<a onClick={() => history(item.first.link)} href='#'><span style={{color: 'rgba(0, 0, 0, 0.45)'}}>{item.first.name}</span></a>
      },
      {
        title:<a href='#'>{item.second.name}</a>
      },
    ];
    return items;
  }

  function itemRender(route: any, params: any, items: any, paths: any) {
    const item = items.indexOf(route);
    if(item == 0) {
      return <span>{route.title}</span>
    } else if(item === 1) {
      return <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>{route.title}</span>
    } else if (item === 2) {
      return <span>{route.title}</span>
    }
  }

  return (
    <div className="advanced-breadcrumb" style={{display: hideBreadCrumb ? 'none' : 'block'}}>
      <Breadcrumb itemRender={itemRender} items={buildItems()} />
    </div>
  )
}

export default AdvancedBreadcrumb